var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12423_29202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.5859C5.8724 24.5859 0.5 19.2135 0.5 12.5859C0.5 5.95834 5.8724 0.585938 12.5 0.585938C19.1276 0.585938 24.5 5.95834 24.5 12.5859C24.5 19.2135 19.1276 24.5859 12.5 24.5859ZM8.3 14.9859V17.3859H11.3V19.7859H13.7V17.3859H14.9C15.6957 17.3859 16.4587 17.0699 17.0213 16.5073C17.5839 15.9446 17.9 15.1816 17.9 14.3859C17.9 13.5903 17.5839 12.8272 17.0213 12.2646C16.4587 11.702 15.6957 11.3859 14.9 11.3859H10.1C9.94087 11.3859 9.78826 11.3227 9.67574 11.2102C9.56321 11.0977 9.5 10.9451 9.5 10.7859C9.5 10.6268 9.56321 10.4742 9.67574 10.3617C9.78826 10.2492 9.94087 10.1859 10.1 10.1859H16.7V7.78594H13.7V5.38594H11.3V7.78594H10.1C9.30435 7.78594 8.54129 8.10201 7.97868 8.66462C7.41607 9.22723 7.1 9.99029 7.1 10.7859C7.1 11.5816 7.41607 12.3446 7.97868 12.9073C8.54129 13.4699 9.30435 13.7859 10.1 13.7859H14.9C15.0591 13.7859 15.2117 13.8492 15.3243 13.9617C15.4368 14.0742 15.5 14.2268 15.5 14.3859C15.5 14.5451 15.4368 14.6977 15.3243 14.8102C15.2117 14.9227 15.0591 14.9859 14.9 14.9859H8.3Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12423_29202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.b1a6625930f6317cb230eae5af1f33e4.svg";
export { ForwardRef as ReactComponent };